import { render } from "./WaitingClaimApproval.vue?vue&type=template&id=3ef2d60a"
import script from "./WaitingClaimApproval.vue?vue&type=script&lang=js"
export * from "./WaitingClaimApproval.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__